import { html } from '@shared/utils/rendering/html';
import { useEffect, useState } from 'preact/hooks';
import Table from '@shared/components/tables';
import {
    FrameworkSortingConfig,
    FrameworksPaginationConfig,
    FrameworksTableColumns,
    FrameworksTableData,
} from '../../../../configs/tables/dashboard/frameworks-table.config';
import { Filter } from '../../../../utils/helpers/static-filter/filter';

const Frameworks = () => {
    const [filteredData, setFilteredData] = useState([]);
    const [config, setConfig] = useState({
        columns: FrameworksTableColumns,
        filters: {
            sorting: {
                ...FrameworkSortingConfig,
                callback: (data) => onSortingUpdate(data),
            },
            pagination: {
                ...FrameworksPaginationConfig,
                paginationEvent: (data) => onPaginate(data),
                total: FrameworksTableData.total,
            },
        },
    });

    const onSortingUpdate = (data) => {
        setConfig((prevConfig) => ({
            ...prevConfig,
            filters: {
                ...prevConfig.filters,
                sorting: {
                    ...prevConfig.filters.sorting,
                    sortByColumn: data.sortByColumn,
                    sortByDescending: data.sortByDescending,
                },
            },
        }));
    };

    const onPaginate = (data) => {
        setConfig((prevConfig) => ({
            ...prevConfig,
            filters: {
                ...prevConfig.filters,
                pagination: {
                    ...prevConfig.filters.pagination,
                    paginationData: {
                        ...prevConfig.filters.pagination.paginationData,
                        pageNumber: data.pageNumber,
                        pageSize: data.pageSize,
                    },
                },
            },
        }));
    };

    useEffect(() => {
        setFilteredData(Filter(FrameworksTableData.rows, config));
    }, [config]);

    return html`
        <${Table}
            config=${config}
            data=${{
                rows: filteredData,
                total: FrameworksTableData.total,
                isLoading: false,
            }}
        />
    `;
};

export default Frameworks;
